<script>
	import { Table } from "@sveltestrap/sveltestrap";
	import LoaderContainer from "../../../../components/Loader/LoaderContainerSort.svelte";
	import { convert, formatSummary } from "../../../../services/helpers";
	import {
		carIssueOpen,
		issueNumber,
		carIssueData,
		isResolvingIssue,
	} from "../../../../store/store";
	export let data;
	export let filteredData;
	export let searchInput;

	const handleOpen = (no) => {
		isResolvingIssue.set(false);
		// Clicking the already-open issue closes it; anything else opens `no`.
		if ($carIssueOpen && $issueNumber == no) {
			carIssueOpen.set(false);
			issueNumber.set("");
		} else {
			carIssueOpen.set(true);
			issueNumber.set(no);
		}
	};
</script>

<LoaderContainer>
	<div class="tbodyDiv">
		<Table responsive hover>
			<thead class="sticky-top">
				<tr>
					<th class="col-3">Issue No.</th>
					<th class="col-4">Summary</th>
					<th class="col-2">Status</th>
					<th class="col-3">Date Reported</th>
				</tr>
			</thead>
			<tbody>
				{#if filteredData.length > 0 || (searchInput && filteredData.length == 0)}
					{#each filteredData as { issueNo, dateReported, status, summary, imageUrls }}
						<tr class={issueNo == $issueNumber ? "bg-table" : ""}>
							<td>
								<p>
									<span
										class="link link-text"
										on:click={() => {
											handleOpen(issueNo);
											carIssueData.set({
												issueNo,
												dateReported,
												status,
												summary,
												imageUrls,
											});
										}}
									>
										{issueNo}
									</span>
								</p>
							</td>
							<td>
								<p>{formatSummary(summary)}</p>
							</td>

							<td>
								{#if status === "Pending"}
									<p class="status-bar status-bar-3">
										Pending
									</p>
								{:else if status === "Resolved"}
									<p class="status-bar status-bar-1">
										Resolved
									</p>
								{/if}
							</td>
							<td>
								{convert(dateReported)}
							</td>
						</tr>
					{/each}
				{:else}
					{#each data as { issueId, issueNo, dateReported, status, summary, imageUrls }}
						<tr class={issueNo == $issueNumber ? "bg-table" : ""}>
							<td>
								<p>
									<span
										class="link link-text"
										on:click={() => {
											handleOpen(issueNo);
											carIssueData.set({
												issueId,
												issueNo,
												dateReported,
												status,
												summary,
												imageUrls,
											});
										}}
									>
										{issueNo}
									</span>
								</p>
							</td>
							<td>
								<p>{formatSummary(summary)}</p>
							</td>

							<td>
								{#if status === "Pending"}
									<p class="status-bar status-bar-3">
										Pending
									</p>
								{:else if status === "Resolved"}
									<p class="status-bar status-bar-1">
										Resolved
									</p>
								{/if}
							</td>
							<td>
								{convert(dateReported)}
							</td>
						</tr>
					{/each}
				{/if}
			</tbody>
		</Table>
	</div>
	{#if data.length === 0 || (searchInput && filteredData.length === 0)}
		<p class="text-center">No issue data to display</p>
	{/if}
	<div>
		Total Record: {searchInput ? filteredData.length : data.length}
	</div>
</LoaderContainer>

<style>
	.tbodyDiv {
		max-height: clamp(38em, 76vh, 550px);
		overflow: hidden;
	}
	.tbodyDiv:hover {
		overflow: auto;
	}
</style>
